import { dateWithOffset } from '$setup/time-offset'

export function getDateOfNYearsAgo(n: number) {
  return new Date(new Date().setFullYear(new Date().getFullYear() - n))
}

export function getDateOfNDaysLater(n: number) {
  return new Date(dateWithOffset() + n * 24 * 3600_000)
}

export function getDateOfNMinutesLater(n: number) {
  return new Date(dateWithOffset() + n * 60_000)
}

export function clampDate(start: Date, end: Date, newDate: Date) {
  if (end < newDate) return end
  if (newDate < start) return start
  return newDate
}
